<script lang="ts">
  import type { ClinicSection } from '@clinic/contracts';
  import { fa } from '../i18n/fa';
  import { cn } from '../lib/cn';

  /**
   * The section of an appointment, visit or entry, in words (ADR-036). The clinic part is the usual
   * case, so it is tagged only where both sections sit side by side (`always`).
   */
  let { section, always = false }: { section: ClinicSection; always?: boolean } = $props();
</script>

{#if section !== 'general' || always}
  <span
    class={cn(
      'inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-[11px] font-medium',
      section === 'laser' ? 'border-info-line bg-info-soft text-info' : 'border-border bg-surface-3 text-text-2',
    )}>{fa.sections.names[section]}</span
  >
{/if}
